import { useSuspenseQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { FetchSavedCreatorsList } from '..';

export const useSavedList = (listId: string) => {
  const queryKeys = useQueryKeys();
  return useSuspenseQuery({
    queryKey: queryKeys.savedCreatorsList.list(),
    queryFn: ({ signal }) => FetchSavedCreatorsList(listId, signal),
  });
};
